import { useState } from 'react';
import styles from './LinkedInPage.module.css';
import { LinkedinIcon, MapPinIcon, BuildingIcon } from '../../icons';

const SKILLS_PREVIEW_COUNT = 5;

const EXPERIENCE = [
  { title: 'Software Architect', company: 'IBM', dates: 'Mar 2024 - Present' },
  { title: 'Staff Software Developer', company: 'IBM', dates: 'Sep 2022 - Mar 2024' },
  { title: 'Associate Software Developer', company: 'IBM', dates: 'Jun 2021 - Sep 2022' },
  { title: 'Software Developer Intern', company: 'IBM', dates: 'May 2018 - Jun 2021' },
];

const CERTIFICATIONS = [
  { name: 'AWS Developer Associate', issuer: 'Amazon Web Services', date: 'Mar 2023' },
];

const SKILLS = [
  { name: 'Go', endorsements: 18 },
  { name: 'Amazon Web Services (AWS)', endorsements: 12 },
  { name: 'Terraform', endorsements: 4 },
  { name: 'React', endorsements: 7 },
  { name: 'TypeScript', endorsements: 14 },
  { name: 'Python', endorsements: 12 },
  { name: 'Databases / SQL', endorsements: 9 },
  { name: 'Google Cloud Platform (GCP)', endorsements: 5 },
  { name: 'IBM Cloud', endorsements: 4 },
  { name: 'Kubernetes', endorsements: 3 },
];

export function LinkedInPage() {
  const [showAllSkills, setShowAllSkills] = useState(false);
  const visibleSkills = showAllSkills ? SKILLS : SKILLS.slice(0, SKILLS_PREVIEW_COUNT);

  return (
    <div className={styles.page}>
      <nav className={styles.nav}>
        <span className={styles.navLogo}><LinkedinIcon /></span>
        <span className={styles.navSearch}>Search</span>
      </nav>

      {/* Profile card */}
      <div className={styles.card}>
        <div className={styles.banner} />
        <div className={styles.profileHeader}>
          <div className={styles.avatarWrap}>
            <img src="/profile.svg" alt="Profile" className={styles.avatar} />
          </div>
          <h1 className={styles.name}>Nicholas Bozentko</h1>
          <p className={styles.headline}>Software Architect</p>
          <p className={styles.location}>
            <MapPinIcon /> New York, NY · 500+ connections
          </p>
          <div className={styles.actions}>
            <span className={styles.btnPrimary}>Connect</span>
            <span className={styles.btnSecondary}>Message</span>
          </div>
        </div>
      </div>

      {/* About */}
      <div className={styles.card}>
        <h2 className={styles.sectionTitle}>About</h2>
        <p className={styles.aboutText}>
          Welcome.
        </p>
      </div>

      {/* Experience */}
      <div className={styles.card}>
        <h2 className={styles.sectionTitle}>Experience</h2>
        <div className={styles.entryList}>
          {EXPERIENCE.map(exp => (
            <div key={exp.title} className={styles.entry}>
              <span className={styles.entryIcon}><BuildingIcon /></span>
              <div>
                <p className={styles.entryTitle}>{exp.title}</p>
                <p className={styles.entrySubtitle}>{exp.company}</p>
                <p className={styles.entryDate}>{exp.dates}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Education */}
      <div className={styles.card}>
        <h2 className={styles.sectionTitle}>Education</h2>
        <div className={styles.entry}>
          <span className={styles.entryIcon}><BuildingIcon /></span>
          <div>
            <p className={styles.entryTitle}>Iona University</p>
            <p className={styles.entrySubtitle}>B.S. Computer Science with Minor in Mathematics</p>
            <p className={styles.entryDate}>2017 - 2021</p>
          </div>
        </div>
      </div>

      {/* Certifications */}
      <div className={styles.card}>
        <h2 className={styles.sectionTitle}>Certifications</h2>
        <div className={styles.entryList}>
          {CERTIFICATIONS.map(cert => (
            <div key={cert.name} className={styles.entry}>
              <span className={styles.entryIcon}><BuildingIcon /></span>
              <div>
                <p className={styles.entryTitle}>{cert.name}</p>
                <p className={styles.entrySubtitle}>{cert.issuer}</p>
                <p className={styles.entryDate}>Issued {cert.date}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Skills */}
      <div className={styles.card}>
        <h2 className={styles.sectionTitle}>Skills</h2>
        <div className={styles.skillList}>
          {visibleSkills.map(skill => (
            <div key={skill.name} className={styles.skillItem}>
              <span className={styles.skillName}>{skill.name}</span>
              <span className={styles.skillCount}>{skill.endorsements} endorsements</span>
            </div>
          ))}
        </div>
        {SKILLS.length > SKILLS_PREVIEW_COUNT && !showAllSkills && (
          <button
            className={styles.seeAll}
            onClick={() => setShowAllSkills(true)}
          >
            Show all {SKILLS.length} skills →
          </button>
        )}
      </div>
    </div>
  );
}
